import React, { useState } from "react";

import googleIcon from "./images/google-icon.webp";
import { Form, Card, Button, Alert, Spinner } from "react-bootstrap";
import "./GenerateReport.css";
import { Link } from "react-router-dom";

const GenerateReport = () => {
  const [isGoogleConnected, setIsGoogleConnected] = useState(false);
  const [authUrl, setAuthUrl] = useState([]);
  const [custDetails, setCustDetails] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [refreshToken, setRefreshToken] = useState("");
  const [pdfLink, setPdfLink] = useState("");
  const [custId, setCustId] = useState([]);

  const handleCustChange = (e) => {
    setCustId([e.target.value, e.target.options[e.target.selectedIndex].text]);
  };

  const handleGoogleConnect = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const response = await fetch(
        "https://birbal-final.zipeline.com/api/connect/",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Token c0a95520160fa9d2fa26552543c48fb99e7e8d17`,
          },
        },
      );
      const url = await response.text();
      let urlObj = new URL(url);
      urlObj.searchParams.set(
        "redirect_uri",
        "https://google-ads-analyzer.vercel.app/",
      );
      let updatedUrl = urlObj.toString();

      // Open the popup after adding the listener
      const authPopup = window.open(
        updatedUrl,
        "authPopup",
        "width=500,height=600",
      );

      if (!authPopup) {
        setIsLoading(false);
        console.error("Popup blocked. Please allow popups for this site.");
      } else {
        // Poll the popup window for changes in its URL
        const checkPopup = setInterval(async () => {
          try {
            if (!authPopup || authPopup.closed) {
              setIsLoading(false);
              clearInterval(checkPopup);
              return;
            }

            // Read the URL from the popup
            const urlParams = new URLSearchParams(authPopup.location.search);
            const code = urlParams.get("code");
            const passthrough_val = urlParams.get("state");

            if (code && passthrough_val) {
              clearInterval(checkPopup);
              setAuthUrl([code, passthrough_val]);
              authPopup.close();
              const getToken = await fetch(
                "https://birbal-final.zipeline.com/api/get-token/",
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify({
                    google_access_code: code,
                    passthrough_val: passthrough_val,
                  }),
                },
              );

              const refreshToken = await getToken.json();
              // console.log(refreshToken)
              setRefreshToken(refreshToken);

              const getCustomers = await fetch(
                "https://birbal-final.zipeline.com/api/get-accounts/",
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify({
                    refresh_token: refreshToken["refresh_token_val"],
                  }),
                },
              );

              const customers = await getCustomers.json();
              if (customers.length > 0) {
                setIsGoogleConnected(true);
                setCustDetails(customers);
                setIsLoading(false);
              }
            }
          } catch (error) {
            // Ignoring cross-origin errors until the popup redirects to your domain
          }
        }, 500); // Check every 500ms
      }
    } catch (e) {
      console.error(e);
    }
    // setIsGoogleConnected(true);
  };

  const handleAccountSubmit = async (e) => {
    e.preventDefault();
    // console.log("cust: ",custId,"refresh: ",refreshToken);
    setIsLoading(true);
    const getPdf = await fetch(
      "https://birbal-final.zipeline.com/api/get_report_data/",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          refresh_token: refreshToken["refresh_token_val"],
          customer_id: custId[0],
          client_name: custId[1],
        }),
      },
    );
    let Link = await getPdf.json();
    setPdfLink(Link["link"]);
    setIsLoading(false);
  };

  return (
    <div className="main-container">
      <Card className="display-card">
        <Card.Header>
          <Card.Title as={"h2"}>Get Report</Card.Title>
        </Card.Header>
        <Card.Body>
          {isLoading ? (
            <Alert className="loading-alert" variant="primary">
              <Spinner animation="border" role="status"></Spinner> Loading
              Please wait...
            </Alert>
          ) : isGoogleConnected ? (
            pdfLink !== "" ? (
              <Link
                to={pdfLink}
                className="btn btn-success"
                target="_blank"
                download
              >
                Download PDF
              </Link>
            ) : (
              <form onSubmit={handleAccountSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label>Select Ac</Form.Label>
                  <Form.Select
                    onChange={handleCustChange}
                    aria-label="Select Account"
                    value={custId[0]}
                    required
                  >
                    <option value="">Select Account</option>
                    {custDetails.map((customer, index) => {
                      return (
                        <option key={index} value={customer["customer_id"]}>
                          {customer["description"]}
                        </option>
                      );
                    })}
                  </Form.Select>
                </Form.Group>
                <button type="submit" className={`btn mb-3 btn-primary`}>
                  Get Report
                </button>
              </form>
            )
          ) : (
            <>
              <Button
                variant="primary"
                onClick={handleGoogleConnect}
                className={`mb-3 btn-google`}
              >
                <img src={googleIcon} alt="connect button" />
                Sign in with Google
              </Button>
              {authUrl.join(", ")}
            </>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default GenerateReport;
